module.exports = __webpack_public_path__ + "static/10-59f9db14f5a4ea3bb8b017e546ebf9ca.png";